import React from 'react';

export default function LoadingSpinner() {
  return (
    <div className="d-flex align-items-center justify-content-center py-5 text-muted">
      <div className="spinner-border" role="status" />
    </div>
  );
}
